import { render, staticRenderFns } from "./InboundBulkChange.vue?vue&type=template&id=7a16391e&"
import script from "./InboundBulkChange.vue?vue&type=script&lang=js&"
export * from "./InboundBulkChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports